import { render, staticRenderFns } from "./ZooHeaderText.vue?vue&type=template&id=26adef9f&scoped=true&"
import script from "./ZooHeaderText.vue?vue&type=script&lang=js&"
export * from "./ZooHeaderText.vue?vue&type=script&lang=js&"
import style0 from "./ZooHeaderText.vue?vue&type=style&index=0&id=26adef9f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26adef9f",
  null
  
)

export default component.exports